import React from 'react'
import PropTypes from 'prop-types'
import {observer} from "mobx-react"

@observer
export default class SubHeader extends React.Component {
  render() {
    return (
      <h3>{this.props.field.name}</h3>
    )
  }
}
